import { WhatsAppUnreadNumUpdateData } from "../../handler/whatsapp/ws-types";
import EventBus from "../event-bus";
const unreadNumUpdateHook = new EventBus<WhatsAppUnreadNumUpdateData>(
  "unreadNumUpdateHook"
);

export default unreadNumUpdateHook;
